import { Form, Input, Select } from "antd";
import type { FormInstance, Rule } from "antd/es/form";
import { useGetModulesQuery } from "../../services/module";
import { useGetCompaniesQuery } from "../../services/company";
import { Actions } from "../../shared/constants";

const SubscriptionForm = ({
  mode,
  subscriptionForm
}: {
  mode: string;
  subscriptionForm: FormInstance;
}) => {
  const requiredRule: Rule = { required: true, message: "Required" };
  const { data: modules, isSuccess: isModulesSuccess, isLoading: isModulesLoading } = useGetModulesQuery({});
  const { data: companies, isSuccess: isCompaniesSuccess, isLoading: isCompaniesLoading } = useGetCompaniesQuery({});
  return (
    <div className="mb-5">
      <Form.Item name="moduleId" label={<>Module<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Select
          placeholder={"Module"}
          filterOption={(input, option) =>
            ((option?.label as string) ?? "").includes(input)
          }
          size="large"
          showSearch
          loading={isModulesLoading}
          options={
            isModulesSuccess &&
            modules?.data?.map((item: any) => ({
              label: item.name,
              value: item.id,
            }))
          }
        />
      </Form.Item>
      <Form.Item name="companyId" label={<>Company<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Select
          placeholder={"Company"}
          filterOption={(input, option) =>
            ((option?.label as string) ?? "").includes(input)
          }
          size="large"
          showSearch
          loading={isCompaniesLoading}
          options={
            isCompaniesSuccess &&
            companies?.map((item: any) => ({
              label: item.name,
              value: item.id,
            }))
          }
        />
      </Form.Item>
      {mode === Actions.EDIT && <Form.Item name="status" label={<>Status<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Select
          placeholder={"Status"}
          size="large"
          options={["Active", "Inactive", "Suspend", "Locked"].map(x => ({ label: x, value: x }))}
        />
      </Form.Item>}
    </div>
  );
};

export default SubscriptionForm;
